import { gql } from '@apollo/client'

export const PublishFamilyMutation = gql`
    mutation publishProductFamily($id: [String]) {
        publishProductFamily(id: $id) {
            instanceId
        }
    }
`

export const PublishOMFamilyMutation = gql`
    mutation OfficeMasterPublishProductFamily(
        $input: OfficeMasterPublishFamilyInput!
    ) {
        officeMasterPublishProductFamily(input: $input) {
            instanceId
        }
    }
`

export const DeleteSustainabilityTopicMutation = gql`
    mutation deleteSustainabilityTopic($id: String!) {
        deleteSustainabilityTopic(id: $id)
    }
`
export const DeletePublishedImportedProductFamilyMutation = gql`
    mutation deletePublishedImportedProductFamily(
        $input: DeletePublishedProductFamilyInput!
    ) {
        deletePublishedImportedProductFamily(input: $input) {
            errorMessage
        }
    }
`
export const UpdateProductFamilyDetailsMutation = gql`
    mutation updateProductFamilyDetails($input: ProductFamilyUpdateInput!) {
        updateProductFamilyDetails(input: $input)
    }
`
export const DeletePublishedImportedOfficeMasterProductFamilyMutation = gql`
    mutation deletePublishedImportedOfficeMasterProductFamily(
        $input: DeletePublishedImportedOfficeMasterProductFamilyInput!
    ) {
        deletePublishedImportedOfficeMasterProductFamily(input: $input) {
            errorMessage
        }
    }
`

export const RenameVersions = gql`
    mutation renameIterations($input: RenameIterationsInput!) {
        renameIterations(input: $input) {
            id
            name
        }
    }
`
export const DeleteMasterSpecCloneOfficeMasterFamilyMutation = gql`
    mutation deleteMasterSpecCloneOfficeMasterFamily(
        $input: DeleteMasterSpecCloneInOfficeMasterInput!
    ) {
        deleteMasterSpecCloneOfficeMasterFamily(input: $input)
    }
`
